<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="更新REDIS UUID" name="first">
      <div style="margin: 20px 20px 20px auto; background-color: white; padding: 20px 20px 0 20px">
        <el-form :inline="true">
          <el-form-item label="UUID:">
            <el-input v-model="UUID" placeholder="请输入UUID" style="width: 500px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-refresh" :plain="true" @click="updateRedisLockControlUuid">更新</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
  </el-tabs>


</template>


<style scoped>

</style>


<script>
import utils from './utils'

export default {
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    updateRedisLockControlUuid(){
      utils.updateRedisLockControlUuid(this.params).then((response)=>{
        if(response.data){
          this.$message.success("设置成功")
        }else{
          this.$message.error("设置失败")
        }
      })
    }
  },
  data() {
    return {
      UUID:'',
      activeName:'first',
    }
  },
  computed: {
    params() {
      return {
        uuid:this.UUID
      };
    },
  },
}
</script>